import { Editor, Element, Transforms } from 'slate';
import { getCurrentNode, isCurrentSelectionCollapsed } from '../../lib/queries';
import { AulaPlugin } from '../plugins';

export const handleDownArrow: AulaPlugin = (editableProps, editor) => ({
  ...editableProps,
  onKeyDown: (e) => {
    const { selection } = editor;
    if (editableProps.onKeyDown) editableProps.onKeyDown(e);
    /**
     * Inserts a default block when ArrowDown is pressed on the last block
     */
    if (
      e.key === 'ArrowDown' &&
      selection != null &&
      isCurrentSelectionCollapsed(editor)
    ) {
      const node = getCurrentNode(editor);
      const last = Editor.range(editor, [editor.children.length - 1]);
      if (
        Editor.isEnd(editor, selection.focus, last) &&
        Element.isElement(node) &&
        !Element.isElementList(node.children)
      ) {
        Transforms.insertNodes(editor, [
          {
            children: [{ text: '' }],
          },
        ]);
      }
    }
  },
});
